<awair-caret-left-icon [color]="index > 0 ? '#64C2E6' : '#ACB4BB'"
                       [style.cursor]="index > 0 ? 'pointer' : 'initial'"
                       (click)="onClickLeft(index)">
</awair-caret-left-icon>
<div class="__space"></div>
<awair-caret-right-icon [color]="index < (length - 1) ? '#64C2E6' : '#ACB4BB'"
                        [style.cursor]="index < (length - 1) ? 'pointer' : 'initial'"
                        (click)="onClickRight(index)">
</awair-caret-right-icon>
